import { useFela } from 'react-fela';

import { VaultActions } from '@/modules/vaults';

import { AddSecretButton } from '../../AddSecretButton';
import { SecretsSearch } from '../../SecretsSearch';
import * as felaRules from './SecretsHeader.rules';

export const SecretsHeader = () => {
    const { css } = useFela();

    return (
        <div className={css(felaRules.container)}>
            <SecretsSearch />
            <div className={css(felaRules.actions)}>
                <VaultActions />
                <AddSecretButton />
            </div>
        </div>
    );
};
